import {Component, Input, OnInit} from '@angular/core';
import {DocumentOptionActionService} from '@shared/services/document-option-action.service';
import {IdName} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';

@Component({
  selector: 'si-mtest-medical-test-download-icon',
  templateUrl: './mtest-medical-test-download-icon.component.html',
  styleUrls: ['./mtest-medical-test-download-icon.component.scss']
})
export class MtestMedicalTestDownloadIconComponent implements OnInit {
  @Input() requestId: number;
  @Input() informedConsents: IdName[];
  @Input() actions: string[];
  @Input() showText = false;
  @Input() hideOnEmpty = false;
  optionValues: IdName[];

  constructor(
    private documentOptionActionService: DocumentOptionActionService
  ) {
  }

  ngOnInit(): void {
    this.initOptionValues();
  }

  initOptionValues(): void {
    this.optionValues = this.documentOptionActionService.initAllOptionValuesMtest(this.actions, this.informedConsents);
  }

  async onSelectOption(option: IdName): Promise<void> {
    this.documentOptionActionService.onSelectOptionMtest(this.requestId, option);
  }
}
